import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=f7f563c2&scoped=true"
import script from "./ArticlesList.vue?vue&type=script&lang=js"
export * from "./ArticlesList.vue?vue&type=script&lang=js"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=f7f563c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f563c2",
  null
  
)

export default component.exports